import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const token = localStorage.getItem('token');
console.log(token);

export async function fetchUserList(UserQuery) {
    console.log("AirportList Request", UserQuery)
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/GetUserList`,
            UserQuery,
            {
                headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': "application/json"
                }
            }
        );
        console.log(response)   
        return response.data;
    } catch (error) {
        console.error('Failed to fetch airport list:', error);
        throw error;
    }
}

export async function addUser(addUserQuery) {
    console.log("Add User Request", addUserQuery)
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/Admin/AddUser`,
            addUserQuery,
            {
                headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': "application/json"
                }
            }
        );
        console.log(response)   
        return response.data;
    } catch (error) {
        console.error('Failed to fetch airport list:', error);
        throw error;
    }
}